<template>
  <t-default-layout active-nav-id="trigger">
    <div :class="componentClassName">
      <a-back-page :id="id" :text="backPageName()" :page="backPage()"/>
      <form
        ref="form"
        class="t-trigger-edit__form"
        enctype="multipart/form-data"
        @submit.prevent="handleFormSubmit"
      >
        <div class="t-trigger-edit__fields">
          <m-section>
            <m-action-card
              :id="idName[1]"
              test-id-text="edit-trigger"
              title="トリガー詳細"
              header-border
              no-header-margin
              icon="clock"
            >
              <div class="t-trigger-edit__fields">
                <a-text id="t-trigger-edit-tirgger-target__a-text">対象：{{ triggerTargetMapping[triggerName] }}</a-text>
                <m-form-input id="t-trigger-edit-pushFlag__form-input">
                  <a-text id="t-trigger-edit-pushFlag__a-text">通知フラグ</a-text>
                  <a-switch id="t-trigger-edit-pushFlag" v-model="triggerData.pushFlag" :disabled="!isSuperUser || isEditingDisabled" />
                </m-form-input>
                <m-form-input>
                  <a-text id="t-trigger-edit-tirgger-summary__a-text">通知テキスト：</a-text>
                  <a-apply-text-field
                    id="title"
                    v-model="triggerData.title"
                    data-testid="edit-trigger-summary-title-input"
                    type="text"
                    maxlength="16"
                    placeholder="タイトル入力"
                    :disabled="!isSuperUser || isEditingDisabled"
                    maxlength-id="add-trigger-edit-title-maxlength"
                  />
                </m-form-input>
                <m-form-input class="t-trigger-edit__text-input">
                  <a-apply-text-field
                    v-model="triggerData.text"
                    data-testid="edit-trigger-summary-content-input"
                    class="t-trigger-edit__content-input"
                    type="textarea"
                    rows="2"
                    maxlength="35"
                    placeholder="テキスト入力"
                    :disabled="!isSuperUser || isEditingDisabled"
                    maxlength-id="add-trigger-edit-text-maxlength"
                  />
                </m-form-input>
                <m-form-input class="t-trigger-edit__schedule-row">
                  <a-text id="t-trigger-edit-schedule-business-days__a-text">通知タイミング設定</a-text>
                  <div class="t-trigger-edit__schedule-days">
                    <a-apply-text-field
                      v-model.number="triggerData.scheduleBusinessDays"
                      data-testid="edit-trigger-schedule-business-days-input"
                      type="number"
                      maxlength="2"
                      placeholder="日数"
                      :disabled="!isSuperUser || isEditingDisabled"
                      maxlength-id="add-trigger-edit-schedule-business-days-maxlength"
                    />
                  </div>
                  <a-text id="t-trigger-edit-schedule-time__a-text" class="t-trigger-edit__schedule-label">営業日目</a-text>
                  <div class="t-trigger-edit__schedule-time">
                    <a-select-field
                      v-model="triggerData.scheduleTime"
                      data-testid="edit-trigger-schedule-time-input"
                      :options="scheduleTimeOptions"
                      :disabled="!isSuperUser || isEditingDisabled"
                      placeholder="時刻"
                    />
                  </div>
                </m-form-input>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[3]" title="配信期間" header-border no-header-margin icon="calendar-setting">
              <div class="t-trigger-edit__fields">
                <div id="t-trigger-edit-cast-start-date-day__row" class="t-trigger-edit__row">
                  <a-text id="t-trigger-edit-cast-start-date__a-text">開始日</a-text>　
                  <m-form-input id="t-trigger-edit-cast-start-date-day__form-input">
                    <a-calendar-field
                      id="cast-start-date-day"
                      v-model="triggerData.deliveryStartDate"
                      test-id-text="edit-trigger-publish-start"
                      :min-date="minDate"
                      mode="dateTime"
                      :disabled="!isSuperUser || isEditingDisabled"
                    />
                  </m-form-input>
                </div>
                <div class="t-trigger-edit__row">
                  <a-text id="t-trigger-edit-cast-end-date__a-text">終了日</a-text>　
                  <m-form-input id="t-trigger-edit-cast-end-date-day__form-input">
                    <a-calendar-field
                      id="cast-end-date-day"
                      v-model="triggerData.deliveryEndDate"
                      test-id-text="edit-trigger-publish-end"
                      :min-date="minDate"
                      mode="dateTime"
                      :disabled="!isSuperUser || isEditingDisabled"
                    />
                  </m-form-input>
                </div>
              </div>
            </m-action-card>
          </m-section>
        </div>
        <m-form-action-buttons>
          <a-button
            v-if="isSuperUser"
            id="saveBtn"
            data-testid="edit-trigger-save-button"
            variant="block"
            color="primary"
            submit="submit"
            >保存</a-button
          >
        </m-form-action-buttons>
      </form>
    </div>

    <!-- Info, Erro Modal -->
    <teleport to="body">
      <o-modal
        id="triggerCreate_resultModal"
        :visible="resultModalVisible"
        class="o-modal--confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span id="triggerCreate_resultModal_body" v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            data-testid="error-info-modal-confirm-button"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseModal"
          />
        </template>
      </o-modal>
    </teleport>
  </t-default-layout>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import ASwitch from '@/components/atoms/switch';
import AText from '@/components/atoms/text';
import ABackPage from '@/components/atoms/back-page';
import MFormInput from '@/components/molecules/form-input';
import ASelectField from '@/components/atoms/select-field';
import AApplyTextField from '@/components/atoms/apply-text-field';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import TDefaultLayout from '@/components/templates/default-layout';
import { messageContent } from '@/common/messageContent.js';
import { customRequest } from '@/common/customRequest.js';
import { customValidate } from '@/common/customValidate.js';
import ACalendarField from '@/components/atoms/calendar-field';
import { utils } from '@/common/utils.js';
import { useVuelidate } from '@vuelidate/core';
import { triggerValidation } from '@/validations/trigger.js';
import { cloneDeep } from 'lodash';

export default {
  name: 't-trigger-edit',
  components: {
    TDefaultLayout,
    MSection,
    MActionCard,
    AText,
    AButton,
    ABackPage,
    MFormInput,
    MFormActionButtons,
    ASwitch,
    ASelectField,
    ACalendarField,
    AApplyTextField,
  },
  mixins: [customRequest, customValidate, messageContent, utils],
  props: {
    class: {
      type: String,
      default: '',
    },
  },

  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  data() {
    return {
      triggerName: this.$route.query.triggerName,
      source: this.$route.query.source,
      idName: [],
      minDate: utils.currentDateTime(),
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      triggerTargetMapping: {
        promote_login: '初回通知許諾をした未ログインユーザー​',
        supervisor_point: '初回ログイン以降起動がない​ビジネスｄアカウント管理者および管理許可子、単独、パーソナルも含めるユーザー',
        login_user_coupon: '初回ログイン以降起動がないログインユーザー（ALL）',
      },
      originalTriggerData: {},
      isEditingDisabled: false,

      //通知データ
      triggerData: {
        triggerName: '',
        type: 'trigger',
        pushFlag: false,
        title: '',
        text: '',
        scheduleBusinessDays: 1,
        scheduleTime: '',
        deliveryStartDate: '',
        deliveryEndDate: '',
      },
      scheduleTimeOptions: (() => {
        const options = [];
        for (let h = 10; h <= 16; h++) {
          const hour = h.toString().padStart(2, '0');
          options.push({ value: `${hour}:00`, label: `${hour}:00` });
          if (h < 17) {
            options.push({ value: `${hour}:30`, label: `${hour}:30` });
          }
        }
        return options;
      })(),
      updatedDataFlag: false,
    };
  },

  validations() {
    return triggerValidation.update();
  },

  computed: {
    isSuperUser() {
      return this.$store.state.user.authInfo === 'manager';
    },
    componentClassName() {
      const baseClassName = mapModifiers('t-trigger-edit');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  created() {
    // テスト用に4件分レンダリングする
    for (let i = 1; i <= 4; i++) {
      this.idName[i] = 'h1-trigger-edit-' + i;
    }
    this.handleGetTriggerInfo();
  },
  mounted() {},
  methods: {
    async handleFormSubmit() {
      // manager権限がない場合は処理を中断
      if (!this.isSuperUser) {
        this.showErrorModal('この操作を行う権限がありません。');
        return;
      }

      const isFormCorrect = await this.v$.$validate();

      if (!isFormCorrect) {
        let errMsg = '';
        this.v$.$errors.map(item => (errMsg += item.$message + '<br>'));
        this.showErrorModal(errMsg);
        return;
      }

      const payload = cloneDeep(this.triggerData);

      if (!messageContent.checkHasSpecialCharacterInObj(payload)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return;
      }

      if (this.triggerName) {
        await this.postRequest('/trigger-notifications/update', { ...payload, triggerName: this.triggerName }).then(res => {
          if (res.status === 'success') {
            this.$router.push({ name: 'Trigger'});
          } else {
            if (res.message) {
              this.showErrorModal(res.message);
            } else {
              this.showErrorModal(messageContent.requireTry('トリガー通知更新'));
            }
          }
        });
      } else {
        this.showErrorModal(messageContent.requireTry('トリガー通知更新'));
      }
    },
    handleGetTriggerInfo() {
      const triggerName = this.$route.query.triggerName;
      if (triggerName) {
        this.postRequest('/trigger-notifications/get', { triggerName: triggerName })
          .then(e => {
            if (e.status === 'success') {
              this.originalTriggerData = cloneDeep(e.data || {});
              const data = e.data || {};
              this.triggerData.pushFlag = data?.pushFlag || false;
              this.triggerData.title = data?.title || '';
              this.triggerData.text = data?.text || '';
              this.triggerData.scheduleBusinessDays = data?.scheduleBusinessDays || 1;
              // scheduleTimeがoptionsに存在するか確認し、存在しない場合は空文字を設定(Firestoreに意図しない時間が入っている場合の制御)
              const timeExists = this.scheduleTimeOptions.some(option => option.value === data?.scheduleTime);
              this.triggerData.scheduleTime = timeExists ? data.scheduleTime : '';
              this.triggerData.deliveryStartDate = data?.deliveryStartDate || '';
              this.triggerData.deliveryEndDate = data?.deliveryEndDate || '';
              this.triggerData.triggerName = data?.triggerName || '';

              // 配信期間中、かつ通知時刻前であれば編集不可にする
              const now = new Date();
              const today = utils.currentDateTime().split(' ')[0]; // 'YYYY-MM-DD'
              const scheduleTime = this.triggerData.scheduleTime;

              if (this.triggerData.pushFlag && this.triggerData.deliveryStartDate && this.triggerData.deliveryEndDate && scheduleTime) {
                const startDate = this.triggerData.deliveryStartDate.split(' ')[0];
                const endDate = this.triggerData.deliveryEndDate.split(' ')[0];

                if (today >= startDate && today <= endDate) {
                  const [hour, minute] = scheduleTime.split(':');
                  const scheduleDateTime = new Date();
                  scheduleDateTime.setHours(parseInt(hour, 10), parseInt(minute, 10), 0, 0);

                  if (now < scheduleDateTime) {
                    this.isEditingDisabled = true;
                  }
                }
              }
            } else {
              this.showErrorModal(messageContent.requireTry('トリガー通知取得'));
            }
            this.updatedDataFlag = true;
          })
          .catch(error => {
            console.error(error);
            this.showErrorModal(messageContent.requireTry('トリガー通知取得'));
          });
      }
    },
    handleCancelClick() {
      const triggerName = this.triggerName;
      const source = this.source;
      if (triggerName && source === 'detail') {
        return this.$router.push({ name: 'TriggerDetail', query: { id: triggerName} });
      } else {
        return this.$router.push({ name: 'Trigger' });
      }
    },
    backPageName() {
      const source = this.source;
      if (source === 'detail') {
        return '詳細画面';
      } else {
        return '一覧画面';
      }
    },
    backPage() {
      const source = this.source;
      if (source === 'detail') {
        return 'TriggerDetail';
      } else {
        return 'Trigger';
      }
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
  },
};
</script>
